<template>
    <li data-top-right-id="search">
        <button @click="toggleSearchDialog" class="btn-search">
            <i class="fas fa-search"></i>
        </button>
    </li>
</template>

<script>
export default {
    name: "NavItemGlobalSearch",
    computed: {
        isDialogOpen() {
            return this.$store.state.isGlobalSearchDialogOpen;
        }
    },
    methods: {
        toggleSearchDialog() {
            this.$store.commit("toggleGlobalSearchDialog", !this.isDialogOpen);
        }
    }
};
</script>

<style lang="scss" scoped>
li {
    list-style-type: none;
}

.btn-search {
    height: 100%;
    padding: 8px;
    border-radius: 4px;
    border: 0;
    background-color: transparent;

    &:focus:not(:focus-visible) {
        outline: 0;
    }
}

@media screen and (min-width: 501px) {
    .btn-search {
        height: min-content;
    }
}
</style>
